module.exports = __webpack_public_path__ + "static/img/__2164.30969b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__2164.jpg
// module id = qfnd
// module chunks = 0